module.exports = __webpack_public_path__ + "img/image-1.85d66cbe.png";